import React, { useEffect, useState } from 'react'
import InputField from './ui/InputField'
import TextAreaField from './ui/TextAreaField';
import FormButton from './ui/FormButton';
import { createChallenge } from '../services/api/challenges/createChallenge';
import { getUnlinkedMissions } from '../services/api/missions/getMission';
import Chip from './ui/Chip';

const ChallengeForm = () => {
  const initData = { title: "", description: "", duration: 7, mission: { title: "", missionId: "" }, ratings: [],viewsLimit:1 };
  const [challenge, setChallenge] = useState(initData);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const initRating = { name: "", threshold: 1 };
  const [currRating, setCurrRating] = useState(initRating);

  useEffect(() => {
    getUnlinkedMissions().then(res => {
      if (!res.error) setOptions(res.data);
    }).catch(e => console.log(e));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChallenge(prev => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setChallenge(initData);
  }

  const handleSelect = (e) => {
    const { value } = e.target;
    const combo = value.split('|');
    setChallenge(prev => ({ ...prev, mission: { title: combo[1], missionId: combo[0] } }));
  }

  const handleRatingsChange = (e) => {
    const { name, value } = e.target;
    setCurrRating(prev => ({ ...prev, [name]: value }));
  }

  const addRating = () => {
    if (currRating.name.length !== 0 && currRating.threshold > 0) {
      for (let i = 0; i < challenge.ratings.length; i++) {
        const element = challenge.ratings[i];
        if(element.name === currRating.name.toLowerCase()) return 0;
      }
      setChallenge(prev => ({ ...prev, ratings: [...prev.ratings, {...currRating,name:currRating.name.toLowerCase()}] }));
      setCurrRating(initRating);
    }
  }

  const handleRemoveRating = (ind) => {
    let copy = challenge.ratings;
    copy.splice(ind,1);
    setChallenge(prev => ({ ...prev, ratings: copy }));
  }

  const handleKeyDown = (e) => {
    if (e.key.toLowerCase() === 'enter') {
      e.preventDefault();
      addRating();
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (challenge.title.trim().length !== 0 && challenge.description.trim().length !== 0 && challenge.duration > 0 && challenge.mission.missionId.length !== 0 && challenge.ratings.length !== 0 && challenge.viewsLimit > 0) {
      setIsLoading(true);
      createChallenge(challenge.title, challenge.description, challenge.duration, challenge.mission.missionId, challenge.ratings, challenge.viewsLimit).then(response => {
        if (!(response.error === null)) {
          alert('an error');
        } else {
          alert('challenge created');
        }
      }).finally(() => {
        setIsLoading(false);
        handleClear();
      });
    } else {
      alert('fill all the details');
    }
  };

  return (
    <div className='flex justify-center'>
      <form method='POST' className='flex flex-col gap-4 min-w-full sm:min-w-[650px] sm:max-w-[650px]' onSubmit={handleSubmit}>
        <p className='text-lg font-semibold text-blue-500 text-center'>Create a new Challenge</p>
        <InputField
          label="Challenge Title"
          name="title"
          value={challenge.title}
          onChange={handleChange}
          required={true}
          placeholder="Enter a challenge title"
        />
        <TextAreaField
          label="Challenge Description"
          name="description"
          value={challenge.description}
          onChange={handleChange}
          placeholder="Enter a detailed description of challenge"
          rows={6}
          required={true}
        />
        <InputField
          label="Challenge Duration(in days)"
          name="duration"
          type='number'
          value={challenge.duration}
          onChange={handleChange}
          required={true}
          placeholder="Enter a challenge duration"
        />
        <div className="flex gap-2 flex-wrap">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select an Mission:</label>
          <select
            value={challenge.mission.title}
            onChange={handleSelect}
            className="block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="" disabled>
              Choose an option
            </option>
            {options.map((option) => (
              <option key={option.mission_id} value={`${option.mission_id}|${option.title}`}>
                {option.title}
              </option>
            ))}
          </select>
        </div>
        <div>
          {challenge.mission.missionId && <Chip label={challenge.mission.title} />}
        </div>

        <div className='flex gap-2'>
          <InputField
            label="Rating Criteria Name"
            name="name"
            value={currRating.name}
            onChange={handleRatingsChange}
            placeholder="Enter rating criterion for challenge"
            className="flex-1"
            onKeyDown={handleKeyDown}
          />
          <InputField
            label="Criteria Threshold Value"
            name="threshold"
            value={currRating.threshold}
            type={'number'}
            onChange={handleRatingsChange}
            placeholder="Enter rating criterion for challenge(0-5)"
            className="flex-1"
            onKeyDown={handleKeyDown}
          />
          <span className='text-blue-500 text-xl self-end pb-2' onClick={addRating} ><i className="fa-solid fa-plus"></i></span>
        </div>
        {challenge.ratings.map((rating, index) => (
          <div className='flex items-center gap-2' key={index}>
            <div className='py-2 px-2 capitalize border-blue-400 border rounded flex-1 text-sm text-wrap break-words'>{rating.name}</div>
            <div className='py-2 px-2 capitalize border-blue-400 border rounded text-sm flex-1'>{rating.threshold}</div>
            <span className='text-red-500' onClick={() => handleRemoveRating(index)} ><i className="fa-solid fa-trash"></i></span>
          </div>
        ))}
        <InputField
          label="Minimum Number of Raters"
          name="viewsLimit"
          type='number'
          value={challenge.viewsLimit}
          onChange={handleChange}
          required={true}
          placeholder="Enter a minimum number of viewers that should rate the challenge video"
        />
        <FormButton
          label={isLoading ? 'Creating...' : 'Create Challenge'}
          type={'submit'}
          disabled={isLoading}
        />
      </form>
    </div>
  )
}

export default ChallengeForm